var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIRkeeper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_2243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11111 0C0.497461 0 0 0.497461 0 1.11111V9.16667H9.16667V0H1.11111Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 0V9.16667H20V1.11111C20 0.497461 19.5026 0 18.8889 0H10.8333Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 10.8334V20H1.11111C0.497461 20 0 19.5026 0 18.8889V10.8334H9.16667Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 19.4444H14.4445V16.6666H11.6667V14.4444H14.4445V11.6666H16.6667V14.4444H19.4445V16.6666H16.6667V19.4444Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_2243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIRkeeper);
export default __webpack_public_path__ + "static/media/i_rkeeper.8fc655e80f2800d94b6fb8369a23f47f.svg";
export { ForwardRef as ReactComponent };